import { useMe } from './useMe'

/**
 * Per-company gate for the Map Planning workspace (COMPASS-1190).
 *
 * Reads the backend-controlled opt-in
 * `CompanySettingsType.mapPlanningEnabled`, part of the `me` query
 * (`GetMeByProjectIds`, `src/api/auth-queries.ts`). Mirrors
 * `useInventoryEnabled`: this hook is the single source of truth for the
 * flag on the frontend — the sidebar entry (`NavigationMenu`), the ⌘K
 * quick-navigation directory (`OmniSearchModal` keeps flag-off module roots
 * out of `buildRouteDirectory`) and the module's route gate
 * (`routes/map-planning/Routes.tsx`) all read it, so a flag-off company
 * neither discovers the page nor reaches it by direct URL.
 *
 * Staff switch the flag on per tenant from Control Center → Feature
 * configuration (catalog key `module.map_planning`); it defaults OFF.
 *
 * FAIL-SAFE: OFF unless the field is `true`. That covers a `null`/missing
 * value from an older row or a partial cache — and a backend that does not
 * know the field at all: a GraphQL server refuses the WHOLE document for an
 * unknown field rather than answering null, so the field is listed in
 * `GET_ME_CONTRACT_FIRST_FIELDS` and `queryMe` re-sends `me` without it
 * (see `src/api/auth-queries.ts`), which is what makes "absent = OFF" true
 * instead of "absent = nobody can boot". Visibility gate only: Map Planning
 * reads the shared container / property / route queries, so there is
 * nothing Map-Planning-specific to enforce server-side.
 */
export const useMapPlanningEnabled = (): boolean =>
  Boolean(useMe()?.company?.companySettings?.mapPlanningEnabled)
